"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskStatusLabel = void 0;
const react_1 = __importDefault(require("react"));
const core_ui_1 = require("@sierralabs/core-ui");
const useTaskStatusColor_1 = require("../hooks/useTaskStatusColor");
const TaskStatusLabel = props => {
    const { task, status, size = 'normal', className = '', getLabel } = props;
    const { color, label: labelValue } = (0, useTaskStatusColor_1.useTaskStatusColor)({
        task,
        status,
        getLabel
    });
    const classes = ['status-label'];
    className && classes.push(className);
    size !== 'normal' && classes.push(size);
    return (react_1.default.createElement(core_ui_1.StyledStatusLabel, { style: color, title: labelValue, className: classes.join(' ') }, labelValue));
};
exports.TaskStatusLabel = TaskStatusLabel;
exports.default = exports.TaskStatusLabel;
//# sourceMappingURL=TaskStatusLabel.js.map